import { useMutation } from '@tanstack/react-query';
import type {
  ExchangeAssetsRequestDto,
  ExchangeAssetsResponseDto,
} from '../types';
import { exchangeAssets } from '../requests';

type Props = {
  onSuccess?: (data: ExchangeAssetsResponseDto) => void;
  onError?: (error: Error) => void;
};

const useAssetsExchange = ({ onSuccess, onError }: Props = {}) => {
  const mutation = useMutation({
    mutationFn: (args: ExchangeAssetsRequestDto) => exchangeAssets(args),
    onSuccess,
    onError,
  });

  return {
    exchangeAssets: mutation.mutateAsync,
    exchangeAssetsResult: mutation.data,
    isExchangeAssetsLoading: mutation.isPending,
    isExchangeAssetsSuccess: mutation.isSuccess,
    isExchangeAssetsError: mutation.isError,
    exchangeAssetsError: mutation.error,
  };
};

export { useAssetsExchange };
